import { createSelector } from 'reselect'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { getObjectUtil } from 'packages/src'

function getByKeyInstanceReduxSelector (domainMapPath, key, value) {
  return createSelector(
    state => getObjectUtil(state, domainMapPath),
    (domainMap) => {
      return Object
        .values(domainMap)
        .find(instance => getValueReduxUtil(instance, key) === value)
    }
  )
}

export {
  getByKeyInstanceReduxSelector
}
